import { render, staticRenderFns } from "./SelectionFullForm.vue?vue&type=template&id=cfa08158"
import script from "./SelectionFullForm.vue?vue&type=script&lang=js"
export * from "./SelectionFullForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports